import { cloneDeep } from 'lodash';
import { reactive } from 'vue';
import { createInitialTableQuery } from '@/store/modules/table/create-initial-table-query';
import { createInitialTableUiState } from '@/store/modules/table/create-initial-table-ui-state';
import type { TableState } from '@/store/modules/table/types';

export const createTableModule = () => {
  const initialQuery = createInitialTableQuery();
  const initialUiState = createInitialTableUiState();

  const table = reactive<TableState>({
    activeTab: 0,
    settingsTabRoute: null,
    menuOverride: null,
    query: initialQuery,
    queryTemporary: cloneDeep(initialQuery),
    activeReports: [],
    activeTabStack: [],
    selectedReport: null,
    filters: {},
    ...initialUiState,
  });

  const setActiveTab = (tabId: number) => {
    table.activeTab = tabId;
  };

  const setSettingsTabRoute = (value: string | null) => {
    table.settingsTabRoute = value;
  };

  const setMenuOverride = (value: string | null) => {
    table.menuOverride = value;
  };

  const reset = () => {
    const freshQuery = createInitialTableQuery();
    const freshUiState = createInitialTableUiState();
    table.activeTab = 0;
    table.settingsTabRoute = null;
    table.menuOverride = null;
    table.query = freshQuery;
    table.queryTemporary = cloneDeep(freshQuery);
    table.activeReports = [];
    table.activeTabStack = [];
    table.selectedReport = null;
    table.filters = {};
    Object.assign(table, freshUiState);
  };

  return {
    state: {
      table,
      setActiveTab,
      setSettingsTabRoute,
      setMenuOverride,
    },
    reset,
  };
};
